<template>
    <div class="st-label-hint">
        <span class="text-truncate">
            <span :class="`label label-xl label-inline label-light-${label.type}`">{{ label.text }}</span>
        </span>
        <div
            v-if="label.hint"
            :class="['st-label-hint-text', label.hintVariant ? `text-${label.hintVariant}` : 'text-dark-50']"
            :title="label.hint"
        >
            {{ label.hint }}
        </div>
    </div>
</template>

<script>
const UNKNOWN_VARIANT = 'dark';

// A table cell: the usual label badge, with a smaller one-line text under it.
// The row says what the cell shows in `labelHints[<field key>]` = { text, type, hint, hintVariant };
// without it the cell is the badge of the field's option, like a labelType column.
export default {
    name: 'LabelHintCustomField',
    props: {
        dataObj: {
            type: Object,
            required: true,
        },
        presenter: {
            type: [String, Number, Boolean],
        },
    },
    computed: {
        label() {
            const { item, field, value } = this.dataObj;
            const custom = item?.labelHints?.[field.key];
            if (custom) {
                return { type: UNKNOWN_VARIANT, ...custom };
            }

            const option = (field.options || []).find((candidate) => candidate.name === value);

            return {
                text: option?.text || value || '-',
                type: option?.type || UNKNOWN_VARIANT,
            };
        },
    },
};
</script>

<style scoped>
/* a text too long for a narrow column ends in an ellipsis; the whole of it shows on hover */
.st-label-hint-text {
    margin-top: 0.35rem;
    font-size: 0.85rem;
    line-height: 1.2;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
